/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable import/extensions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-mixed-operators */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as ApplicationStatusIcon } from "../../assets/logos/ApplicationStatusAgent.svg";
import { ReactComponent as BenefitAgentIcon } from "../../assets/logos/BenefitAgent.svg";
import { ReactComponent as DocumentAgentIcon } from "../../assets/logos/DocumentQualityAgent.svg";
import { ReactComponent as EligibilityAgentIcon } from "../../assets/logos/EligibilityReviewAgent.svg";
import { ReactComponent as ReviewAgentIcon } from "../../assets/logos/IntakeReviewAgent.svg";
import { KEY_INSIGHTS_CONFIG } from '../../config/agentic/keyInsightsConfig';
import { AGENT_METRICS } from '../../config/agentic/metricsConfig.js';
import { AGENT_NAME_TO_ID, AGENT_TYPES } from "../../constants/agentTypes";
import '../../styles/AppScreen.css';
import { agenticGet } from "../../utils/agenticApiClient";
import { convertFormattedDuration } from '../../utils/formateDate.js';
import {
  paginate,
  sortWeekDays
} from '../../utils/helper.js';
import ActionCard from '../sharedComponents/ActionCard';
import ActivityFeedCard from '../sharedComponents/ActivityFeedCard';
import { transformApiResponse } from '../sharedComponents/agents/applicationHistoryNormalizer.js';
import AppHeader from '../sharedComponents/AppHeader';
import SampleDataBanner from '../sharedComponents/SampleDataBanner';
import ApplicationsBarChart from '../sharedComponents/ApplicationsBarChart';
import ApplicationTable from '../sharedComponents/BenefitAgent/ApplicationTable';
import CaseStatusCard from '../sharedComponents/CaseStatusCard.jsx';
import DuplicatesLineChart from '../sharedComponents/DuplicatesLineChart';
import IncomingApplication from '../sharedComponents/IncomingApplication.jsx';
import IntakeAgentPanel from '../sharedComponents/IntakeAgent/IntakeAgentPanel';
import KeyInsightsCard from '../sharedComponents/KeyInsightsCard';
import NavBar from '../sharedComponents/NavBar';
import { APPS_TABS } from '../sharedComponents/navTabs';
import PageHeader from '../sharedComponents/PageHeader';
import ApplicationStatusReport from '../sharedComponents/Report/ApplicationStatusReport.jsx';
import BenefitsAgentReport from '../sharedComponents/Report/BenefitAgentReport.jsx';
import DocumentQualityReport from '../sharedComponents/Report/DocumentQualityReport.jsx';
import EligibilityReport from '../sharedComponents/Report/ElligibilityReport.jsx';
import IntakeAgentReport from '../sharedComponents/Report/IntakeAgentReport.jsx';

const ReliefManScreen = ({
  logedInUserMail, entries,
  actionItems,
  // stats,
  agentName, pageTitle,
  title, subtitle, backPath,
}) => {
  const [isAgentPanelOpen, setIsAgentPanelOpen] = useState(false);
  const [defaultMsg, setDefaultMsg] = useState(null);
  const [metricsResponse, setMetricsResponse] = useState(null);
  const [metricsLoading, setMetricsLoading] = useState(true);
  const location = useLocation();
  const reportData = location.state?.reportData;

  const [caseStatusItems, setCaseStatusItems] = useState([]);
  const [caseStatusCount, setCaseStatusCount] = useState(0);
  const [caseStatusLoading, setCaseStatusLoading] = useState(false);
  const [transformedEntries, settransformedEntries] = useState([]);
  const agentId = reportData?.agentId;
  const isApplicationStatusAgent =
    agentName === AGENT_TYPES.APPLICATION_STATUS;

  const reportComponentMap = {
    [AGENT_TYPES.APPLICATION_STATUS]: ApplicationStatusReport,
    [AGENT_TYPES.ELIGIBILITY_REVIEW]: EligibilityReport,
    "benefit-agent-b1": BenefitsAgentReport,
    DocumentProcessingAgent: DocumentQualityReport,
  };

  const ReportComponent =
    reportComponentMap[agentName] ||
    reportComponentMap[agentId] ||
    (agentId === "review-intake-a1" && !isApplicationStatusAgent
      ? IntakeAgentReport
      : null);

  const keyInsightAgentId = AGENT_NAME_TO_ID[agentName];

  const fetchApplicationHistory = async (caseId) => {
    try {
      const response = await agenticGet(`/application-history?case_id=${caseId}`);
      const transformedEntries = transformApiResponse(response.data);
      settransformedEntries(transformedEntries); // Set transformed entries data
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
      return () => { document.title = 'IVA - Intelligent Virtual Assistant'; };
    }
    return undefined;
  }, [pageTitle]);
  
  const applicationData = [
    {
      caseId: "2034",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Lois Griffin",
      assignedTo: "Lois Griffin",
      Notes: "Assigned for benefit search; insurance status unknown",
    },
    {
      caseId: "2035",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "John Doe",
      assignedTo: "John Doe",
      Notes: "Benefit check to confirm external assistance",
    },
    {
      caseId: "2036",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Sam Smith",
      assignedTo: "John Doe",
      Notes: "DOB check assigned, applicant reported FEMA registration",
    },
    {
      caseId: "2037",
      appStatus: "For Benefit Search",
      lastUpdate: "2025-10-01",
      updateBy: "Sam Smith",
      assignedTo: "John Doe",
      Notes: "Routed for benefit verification",
    },

  ];

  const isReviewAgentScreen = title === "Duplicate Report" || agentName === "Intake Review Agent" || agentName === "Document Quality Agent" || agentName === "Eligibility Review Agent";

  /* ================= CASE ROW ================= */
  const mapDocumentCaseRow = (apiCase) => ({
    caseId: apiCase?.caseId || apiCase?.case_id || "-",
    submitDate: apiCase?.submitted_on || "-",
    origin: apiCase?.origin || "-",
    firstName: apiCase?.applicant_first_name || "-",
    lastName: apiCase?.applicant_last_name || "-",
    caseManager: apiCase?.case_manager || "-",
    updatedAt: apiCase?.updated_at || "-",
    notes: "Document quality check completed",
  });

  useEffect(() => {
    if (!keyInsightAgentId) return;

    const metricsConfig = AGENT_METRICS[keyInsightAgentId];

    // STATIC → no API call
    if (metricsConfig?.type === "static") {
      setMetricsLoading(false);
      setMetricsResponse(null);
      return;
    }

    if (!metricsConfig?.api) {
      setMetricsLoading(false);
      return;
    }

    const fetchMetrics = async () => {
      try {
        setMetricsLoading(true);
        const data = await agenticGet(metricsConfig.api);
        setMetricsResponse(data);
      } catch (err) {
        console.error("Metrics API error:", err);
        setMetricsResponse(null);
      } finally {
        setMetricsLoading(false);
      }
    };

    fetchMetrics();
  }, [keyInsightAgentId]);

  const stats = (() => {
    if (!keyInsightAgentId || !AGENT_METRICS[keyInsightAgentId]) return [];

    const config = AGENT_METRICS[keyInsightAgentId];

    // STATIC METRICS
    if (config.type === "static") {
      const data = typeof config.getData === "function"
        ? config.getData()
        : config.data;

      return data
        .map((stat) => {
          const ui = KEY_INSIGHTS_CONFIG[stat.iconKey];
          if (!ui) return null;

          return {
            title: stat.title ?? ui.title,
            value: stat.value,
            hint: stat.hint,
            label: stat.label,
            icon: ui.icon,
            labelIcon: stat.labelIcon ?? ui.labelIcon,
          };
        })
        .filter(Boolean);
    }

    // API METRICS
    if (config.api && metricsResponse) {
      return config
        .mapResponse(metricsResponse)
        .map((stat) => {
          const ui = KEY_INSIGHTS_CONFIG[stat.iconKey];
          if (!ui) return null;
          return {
            title: stat.title ?? ui.title,
            value: stat.value,
            hint: stat.hint,
            label: stat.label,
            icon: ui.icon,
            labelIcon: stat.labelIcon ?? ui.labelIcon,
          };
        })
        .filter(Boolean);
    }

    return [];
  })();

  const hasMetrics = Boolean(keyInsightAgentId && AGENT_METRICS[keyInsightAgentId]);

  // const totalItems = Math.max(
  //   primaryApplicationData.length,
  //   potentialDuplicates.length,
  //   duplicateApplications.length,
  // );

  // const totalPages = Math.ceil(totalItems / PAGE_SIZE);
  const isDocumentQualityReport = location.pathname === "/documentQuality-report"

  const chartData = metricsResponse?.application_intake?.map((item) => ({
    day: item.weekday,
    value: item.count,
  })) || [];

  const weeklyData = metricsResponse?.weekly_performance?.map((item) => ({
    day: item.weekday,
    value: item.count,
  })) || [];

  const shouldHideDashboard = agentName === AGENT_TYPES.INTAKE_REVIEW_AGENT
    && title === "Duplicate Report";

  const shouldHideDashboardBenefit = agentName === "Benefits Agent" && title === "Benefits Report";

  const AGENT_ICON_MAP = {
    [AGENT_TYPES.APPLICATION_STATUS]: ApplicationStatusIcon,
    [AGENT_TYPES.ELIGIBILITY_REVIEW]: EligibilityAgentIcon,
    [AGENT_TYPES.DOCUMENT]: DocumentAgentIcon,
  };

  const getAgentIcon = () => {
    if (AGENT_ICON_MAP[agentName]) return AGENT_ICON_MAP[agentName];
    if (isReviewAgentScreen) return ReviewAgentIcon;
    return BenefitAgentIcon;
  };
  const Icon = getAgentIcon();
  const isApplicationStatusReport = location.pathname === "/application-status-report";
  const handleTrigger = (text) => {
    setDefaultMsg(`Check application status of ${text}`);
    setIsAgentPanelOpen(true);
  };

  const fetchCaseStatus = async (name) => {
    // TODO: Need to implement filter change on other agent pages as well
    if (!isApplicationStatusAgent) return;
    settransformedEntries([]);
    try {
      setCaseStatusLoading(true);

      const data = await agenticGet(`/latest-status?program_name=${encodeURIComponent(name)}`);
      const mappedItems = (data || []).map((item) => {
        const duration = item.status_duration || {};
        const formattedDuration = convertFormattedDuration(duration);

        return {
          text: item.case_id,
          duration: formattedDuration,
          status: item.note_type || "-",
          type: item.note_sub_type === "Inactive" ? "warning" : "",
        };
      });
      setCaseStatusItems(mappedItems || []);
      setCaseStatusCount(mappedItems.length);
    } catch (error) {
      console.error("Case Status API Error:", error);
    } finally {
      setCaseStatusLoading(false);
    }
  };

  return (
    <div className={`chat-container ${isAgentPanelOpen ? 'chat-open' : ''}`}>
      <NavBar logedInUserMail={logedInUserMail} tabs={APPS_TABS} activeTabKey="agents" />
      <div className="agentAppContainer">
        <div className={`main-wrapper ${isAgentPanelOpen ? "panel-open" : ""} ${!reportData ? "sample-mode" : ""}`}>

          <div className="hello-trigger" onClick={() => setIsAgentPanelOpen(true)}>
            <Icon
              className="agent-icon"
              title="Chat with Agent"
              aria-label="Chat with Agent"
            />
          </div>
          {!reportData && <SampleDataBanner onChatClick={() => setIsAgentPanelOpen(true)} />}

          <PageHeader
            title={title}
            subtitle={subtitle}
            backPath={backPath}
          />

          <div className="sample-content-wrapper">
            {!isDocumentQualityReport && !shouldHideDashboardBenefit
              && !shouldHideDashboard && (agentName === AGENT_TYPES.BENEFITS
                || agentName === AGENT_TYPES.INTAKE_REVIEW_AGENT
                || agentName === AGENT_TYPES.DOCUMENT || agentName === AGENT_TYPES.ELIGIBILITY_REVIEW) && !reportData && (

                <>
                  <AppHeader title={pageTitle} />

                  <div className="dashboard-row">

                    <div className="card-wrapper left">
                      <div className="card-header-row">
                        <div className="card-title-outside">Action Items</div>
                      </div>

                      <ActionCard
                        count={26}
                        items={actionItems}
                        subText="Waiting for review"
                      />
                    </div>

                    <div className="card-wrapper right">
                      <div className="card-header-outside-v2">

                        <div className="card-header-left-v2">
                          <div className="card-title-outside">Activity Feed</div>
                        </div>

                        <a href="#view" className="view-all-link">
                          View All
                        </a>
                      </div>
                      <ActivityFeedCard entries={entries} onAskAgent={(e) => setIsAgentPanelOpen(true)} />

                    </div>

                  </div>
                </>
              )}
            {agentName === AGENT_TYPES.APPLICATION_STATUS && !isApplicationStatusReport && !reportData && (
              <>
                {' '}
                <AppHeader onProgramChange={(programName) => fetchCaseStatus(programName)} title={pageTitle} />
                {' '}

                <div className="dashboard-row application-status-wrap">

                  <div className="card-wrapper left">
                    <div className="card-title-outside">Active Overdue Cases</div>
                    <CaseStatusCard
                      count={caseStatusLoading ? "..." : caseStatusCount}
                      items={caseStatusLoading ? [] : caseStatusItems}
                      subText="Total Overdue Cases"
                      handleSelection={(e) => {
                        fetchApplicationHistory(e);
                      }}
                    />
                  </div>

                  <div className="card-wrapper right">
                    <div className="card-header-outside">
                      <div className="card-title-outside">Case History</div>
                      <a href="#view" className="view-all-link">View All</a>
                    </div>
                    <ActivityFeedCard entries={transformedEntries} onAskAgent={(e) => handleTrigger(e)} />
                  </div>

                </div>
              </>
            )}

            {!isDocumentQualityReport && hasMetrics && !shouldHideDashboard && !reportData && (
              <div className="dashboard-row">
                <div className="card-wrapper ki">
                  <div className="card-header-row">
                    <div className="card-title-outside">
                      {agentName === AGENT_TYPES.DOCUMENT
                        ? "Key Performance Metrics"
                        : "Key Insights"}
                    </div>
                  </div>
                  {!metricsLoading && (
                    <KeyInsightsCard agentName={agentName} stats={stats} />
                  )}
                </div>
              </div>
            )}

            {(agentName === AGENT_TYPES.ELIGIBILITY_REVIEW) && !reportData && (
              <div className="dashboard-row">
                <div className="card-wrapper ki">
                  <div className="card-header-left-v2 mb-1">
                    <div className="card-title-outside">
                      Incoming Applications
                    </div>
                  </div>
                  <div className="charts-row w-50">

                    <div className="chart-box">
                      <IncomingApplication
                        title="Received Applications by Month"
                        tooltipLabel="Applications"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {(agentName === AGENT_TYPES.DOCUMENT) && !isDocumentQualityReport &&  !reportData && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-header-left-v2 mb-1">
                  <div className="card-title-outside">
                    Document Verification Performance
                  </div>
                </div>
                <div className="charts-row w-50">

                  <div className="chart-box">
                    <IncomingApplication
                      title="Rejected Documents by Month"
                      tooltipLabel="Documents"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {agentName !== AGENT_TYPES.DOCUMENT && hasMetrics && !shouldHideDashboard && agentName !== AGENT_TYPES.ELIGIBILITY_REVIEW && (
            <div className="dashboard-row">
              <div className="card-wrapper ki">
                <div className="card-header-left-v2 mb-1">
                  <div className="card-title-outside">
                    Weekly Intake Performance
                  </div>
                </div>
                <div className="charts-row">

                  <div className="chart-box">
                    <DuplicatesLineChart data={sortWeekDays(weeklyData)} agentName={agentName} />
                  </div>

                  <div className="chart-box">
                    <ApplicationsBarChart data={sortWeekDays(chartData)} agentName="Applications" />
                  </div>

                </div>
              </div>
            </div>
          )}
          {agentName === "Benefits Agent" && !shouldHideDashboardBenefit && (
            <div className="card-wrapper">
              <div className="card-header-left-v2">
                <div className="card-title-outside">
                  Applications
                </div>
              </div>
              <ApplicationTable data={paginate(applicationData, 1)} />
            </div>
          )}

          {reportData && ReportComponent && (
            <ReportComponent reportData={reportData} />
          )}
          <div className={`agent-panel-wrapper ${isAgentPanelOpen ? "open" : ""}`}>
            <IntakeAgentPanel
              userName="User"
              applicationCount={9}
              onRunDuplicateCheck={() => console.log("Run duplicate check")}
              onSaveForLater={() => console.log("Saved for later")}
              onClose={() => setIsAgentPanelOpen(false)}
              defaultMsg={defaultMsg}
              agentName={agentName}
              isReviewAgentScreen={isReviewAgentScreen}
              logedInUserMail={logedInUserMail}
              isAgentPanelOpen={isAgentPanelOpen}
            />
          </div>

        </div>
      </div>
    </div>
  );
};
ReliefManScreen.propTypes = {
  logedInUserMail: PropTypes.string.isRequired,
};

export default ReliefManScreen;
